<template>
  <a-drawer width="50%" :label-col="4" :wrapper-col="14" :visible="visible" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="handleQuery">
        <a-row :gutter="10">
          <a-col :md="12" :sm="16">
            <a-form-item label="姓名" prop="nickname">
              <a-input v-model="queryParam.nickname" placeholder="请输入昵称" allow-clear/>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-form-item label="手机号" prop="mobile">
              <a-input v-model="queryParam.mobile" placeholder="请输入手机号" allow-clear/>
            </a-form-item>
          </a-col>
          <a-col :md="7" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="handleQuery" icon="search">查询</a-button>
              <a-button type="primary" @click="resetQuery" icon="reload" style="margin-left: 8px">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!-- 操作按钮区域 -->
    <div class="table-operations">
      <table-setting
        :style="{float: 'right'}"
        :table-size.sync="tableSize"
        v-model="columns"
        :refresh-loading="loading"
        @refresh="getList"/>
    </div>
    <!-- table区域-begin -->
    <div>
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :pagination="false"
        :scroll="{ x: 800}"
        :bordered="tableBordered"
      >
        <!--            <span slot="action" slot-scope="text, record">-->
        <!--              <a @click="handleEdit(record)">编辑</a>-->
        <!--            </span>-->

      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </div>
    <!-- table区域-end -->
  </a-drawer>
  <!-- 表单区域 -->
</template>

<script>
import { pageClientUser } from '@/api/biz/user'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'ClientForm',
  mixins: [tableMixin],
  components: { },
  data() {
    return {
      description: '分类标签管理页面',
      screenWidth: 800,
      formTitle: '员工列表',
      visible: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      ids: [],
      model: {},
      labelCol: {
        xs: { span: 5 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 12 },
        sm: { span: 12 }
      },
      form: this.$form.createForm(this),
      loading: false,
      companyId: null,
      total: 0,
      queryParam: {
        nickname: null,
        mobile: null,
        topUserId: null,
        companyId: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: '姓名',
          dataIndex: 'realName',
          ellipsis: true,
          width: 120,
          fixed: 'left',
          align: 'center'
        },
        {
          title: '手机号',
          dataIndex: 'mobile',
          ellipsis: true,
          width: 120,
          fixed: 'left',
          align: 'center'
        },
        {
          title: '用户ID',
          dataIndex: 'id',
          ellipsis: true,
          width: 180,
          align: 'center'
        },
        {
          title: '身份证号',
          dataIndex: 'idCard',
          ellipsis: true,
          width: 180,
          align: 'center'
        },
        {
          title: '性别',
          dataIndex: 'sex',
          ellipsis: true,
          width: 80,
          align: 'center',
          customRender: function (sex) {
            if (sex === 0) {
              return '保密'
            } else if (sex === 1) {
              return '男'
            } else if (sex === 2) {
              return '女'
            }
          }
        }
      ]
    }
  },
  filters: {},
  computed: {},
  created() {
  },
  watch: {},
  methods: {
    getList() {
      this.loading = true
      this.queryParam.companyId = this.companyId
      pageClientUser(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    handleQuery(record) {
      if (record.id) {
        this.companyId = record.id
      }
      this.queryParam.pageNum = 1
      this.getList()
      this.visible = true
    },
    resetQuery() {
      this.queryParam = {
        mobile: undefined,
        nickname: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.getList()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onClose() {
      this.visible = false
      this.form.resetFields()
      this.list = []
    }
  }
}
</script>
